import { render, staticRenderFns } from "./pupil-edit.vue?vue&type=template&id=73091d1e"
import script from "./pupil-edit.vue?vue&type=script&lang=js"
export * from "./pupil-edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports